module.exports = __webpack_public_path__ + "img/sweater1.4f4b9f81.png";